import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionCta } from '../components/SectionCta';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-brand-50 py-14 sm:py-20" aria-labelledby="shift-heading" data-id="element-103" data-mp="3ltlm9s7pcc4r">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-104" data-mp="3qr3vljpmstda">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600" data-id="element-105" data-mp="3qpixjk43ysao">
          The shift
        </p>
        <h2 id="shift-heading" className="mx-auto mt-3 max-w-2xl text-center font-display text-[26px] font-black leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-106" data-mp="mdyobdnxeqtq">
          Stop improvising every planning.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-ink-700 sm:text-lg" data-id="element-107" data-mp="df3gxy95baou">
          Follow a structured clinical system designed to help you make better decisions from
          diagnosis through finalization.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-108" data-mp="2fyn3vl7e8xau">
          <div className="rounded-2xl border border-navy-900/10 bg-white p-5 sm:p-6" data-id="element-109" data-mp="2bw0b9i2wf8cl">
            <div className="flex items-center gap-2.5" data-id="element-110" data-mp="2byd1eiit8p0q">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-red-100" data-id="element-111" data-mp="2pwktac0zp051">
                <XIcon aria-hidden="true" className="h-4 w-4 text-red-600" data-id="element-112" data-mp="2kvx3ftohypce" />
              </span>
              <h3 className="font-display text-lg font-extrabold uppercase tracking-tight text-navy-900 sm:text-xl" data-id="element-113" data-mp="2yv55qvfyidkt">
                Before
              </h3>
            </div>
            <ul className="mt-5 space-y-2.5" data-id="element-114" data-mp="38mstomdb1chj">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-115" data-mp="33mo8ij1gbtkz">
                  <XIcon aria-hidden="true" className="mt-[3px] h-4 w-4 shrink-0 text-red-500" data-id="element-116" data-mp="33pitcbodngex" />
                  <span className="text-[13.5px] leading-snug text-ink-700 sm:text-[15px]" data-id="element-117" data-mp="3dmf6wvt4usqc">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border-2 border-brand-500 bg-white p-5 shadow-card sm:p-6" data-id="element-118" data-mp="3po6nlefzhiki">
            <div className="flex items-center gap-2.5" data-id="element-119" data-mp="3ul5gxurtplhn">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-emerald-100" data-id="element-120" data-mp="37sr0b74gpdn">
                <CheckIcon aria-hidden="true" className="h-4 w-4 text-emerald-700" data-id="element-121" data-mp="87orw1kiw0oz" />
              </span>
              <h3 className="font-display text-lg font-extrabold uppercase tracking-tight text-navy-900 sm:text-xl" data-id="element-122" data-mp="c87jpvmf16r6">
                With the System
              </h3>
            </div>
            <ul className="mt-5 space-y-2.5" data-id="element-123" data-mp="m6ofr707obk3">
              {afterItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-124" data-mp="2iz6u27xyzqlh">
                  <CheckIcon aria-hidden="true" className="mt-[3px] h-4 w-4 shrink-0 text-emerald-600" data-id="element-125" data-mp="2j11gxrssxss7" />
                  <span className="text-[13.5px] font-medium leading-snug text-navy-900 sm:text-[15px]" data-id="element-126" data-mp="2gfty14k1wvon">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <SectionCta label="Start planning with a system" data-id="element-127" data-mp="26muxcoba5eoo" />
      </div>
    </section>;
}